/**
 *  publishing status enum
 */
export enum PublishStatus {
    PRIVATE = "private",
    PUBLISHED = "published",
    UNLISTED = "unlisted",
}
